import { TOKEN_RE, TOKEN_SIZE } from "./constants.js";
import { randomBytes, sha256, toBase64Url, utf8 } from "./bytes.js";
import { LscError } from "./errors.js";

/**
 * §3 — access token T: 24 random bytes, canonical form = base64url string (32 chars).
 * The canonical string form is what travels in `Authorization: Bearer` and what gets hashed.
 */
export function generateToken(): string {
  return toBase64Url(randomBytes(TOKEN_SIZE));
}

export function isValidToken(token: unknown): token is string {
  return typeof token === "string" && TOKEN_RE.test(token);
}

/** Server stores only this: base64url( SHA-256( UTF-8(token) ) ) — 43 chars. */
export async function hashToken(token: string): Promise<string> {
  if (!isValidToken(token)) throw new LscError("BAD_INPUT", "invalid token");
  return toBase64Url(await sha256(utf8(token)));
}
